export const sidebar = [
  {
    icon: "mdi-monitor",
    name: "Dashboard",
    to: "/dashboard"
  }
];
export const sidebar2 = [];
export const mainMenu = [
  {
    icon: "mdi-briefcase",
    name: "Employee ",
    to: "/employee",
    color: "#01cce0"
  },
  {
    icon: "mdi-map-marker-radius",
    name: "Address",
    to: "/personal",
    color: "#01a651"
  },
  {
    icon: "mdi-clipboard-text",
    name: "Additional Information",
    to: "/additional-info",
    color: "#ffd600"
  },
  {
    icon: "mdi-folder-account",
    name: "Master User",
    to: "/master-user",
    color: "#0080ff",
    role: "Admin"
  },
  {
    icon: "mdi-calendar-today",
    name: "Master Leave Allowance",
    to: "/master-leave",
    color: "#f19000",
    role: "Admin"
  },
  {
    icon: "mdi-cash-100",
    name: "Master Cost Center",
    to: "/master-cost/",
    color: "#922323",
    role: "Admin"
  },
  {
    icon: "mdi-city",
    name: "Master Job Grade",
    to: "/master-job-grade/",
    color: "#000000",
    role: "Admin"
  },
  {
    icon: "mdi-sitemap",
    name: "Role Management",
    to: "/role-management/",
    color: "#ff0000",
    role: "Admin"
  },
  {
    icon: "mdi-file-export",
    name: "curriculum vitae",
    to: "/curriculum-vitae",
    color: "#ff0000",
    role: "Admin"
  }
];
export const mainMenuGuest = [
  {
    icon: "mdi-briefcase",
    name: "Employee",
    to: "/employee",
    color: "#01cce0"
  },
  {
    icon: "mdi-map-marker-radius",
    name: "Address",
    to: "/personal",
    color: "#01a651"
  },
  {
    icon: "mdi-clipboard-text",
    name: "Additional Information",
    to: "/additional-info",
    color: "#ffd600"
  }
];
